import { useLayoutEffect } from 'react';
import { useWindowWidth } from '../../utilities';
import { addRemoveTitleAttribute, getTitleOnTruncateElements } from '../utils';

/**
 * @Component TruncationTitleLogic
 * @returns jsx styled with truncation based upon component logic
 **/

const TruncationTitleLogic = () => {
  /* saving this function to a variable for proper use in the useLayoutEffect hook */
  const scanWindow = useWindowWidth(300);

  /**
   *  This part runs on initial page load
   *  It also watches scanWindow (which looks at useWindowWidth, which watches the screen size)
   *  and runs whenever the screen size changes
   */
  useLayoutEffect(() => {
    const potentialTruncatedElements = getTitleOnTruncateElements();
    [...potentialTruncatedElements].forEach(addRemoveTitleAttribute);
  }, [scanWindow]);

  return null;
};

export { TruncationTitleLogic };
